import { render } from "./RelatedArticle.vue?vue&type=template&id=1c0d9190"
import script from "./RelatedArticle.vue?vue&type=script&lang=js"
export * from "./RelatedArticle.vue?vue&type=script&lang=js"

import "./RelatedArticle.vue?vue&type=style&index=0&id=1c0d9190&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__